import { render, staticRenderFns } from "./start-course-work-component.vue?vue&type=template&id=682c8ee2"
import script from "./start-course-work-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./start-course-work-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./start-course-work-component.vue?vue&type=style&index=0&id=682c8ee2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports